import { isSvgTag } from './node-factory';
const XLINK_NAMESPACE = 'http://www.w3.org/1999/xlink';
const XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
export function applyStyles(element, props) {
    element.removeAttribute('style');
    if (props.style) {
        if (typeof props.style === 'string') {
            element.setAttribute('style', props.style);
        }
        else if (typeof props.style === 'object') {
            applyStyleObject(element, props.style);
        }
    }
}
export function applyAttributes(element, nodeId, props, context) {
    if (props.id) {
        element.id = String(props.id);
    }
    else {
        element.removeAttribute('id');
    }
    if (shouldApplyFormControlName(element, props)) {
        const explicitName = props.name;
        if (explicitName !== undefined && explicitName !== null && String(explicitName).length > 0) {
            element.setAttribute('name', String(explicitName));
        }
        else if (props.id) {
            element.setAttribute('name', String(props.id));
        }
        else {
            element.setAttribute('name', `smth-${nodeId}`);
        }
    }
    setOrRemoveAttribute(element, 'role', props.role);
    setOrRemoveAttribute(element, 'lang', props.lang);
    setOrRemoveAttribute(element, 'tabindex', props.tabIndex);
    setOrRemoveAttribute(element, 'for', props.for ?? props.htmlFor);
    setOrRemoveAttribute(element, 'rel', props.rel);
    setOrRemoveAttribute(element, 'aria-label', props.ariaLabel ?? props['aria-label']);
    setInert(element, props.inert);
    setOrRemoveAttribute(element, 'aria-hidden', props.ariaHidden ?? props['aria-hidden']);
    setOrRemoveAttribute(element, 'aria-haspopup', props.ariaHasPopup ?? props['aria-haspopup']);
    setOrRemoveAttribute(element, 'aria-expanded', props.ariaExpanded ?? props['aria-expanded']);
    setOrRemoveAttribute(element, 'aria-controls', props.ariaControls ?? props['aria-controls']);
    setOrRemoveAttribute(element, 'aria-owns', props.ariaOwns ?? props['aria-owns']);
    setOrRemoveAttribute(element, 'aria-modal', props.ariaModal ?? props['aria-modal']);
    setOrRemoveAttribute(element, 'aria-activedescendant', props.ariaActiveDescendant ?? props['aria-activedescendant']);
    setOrRemoveAttribute(element, 'aria-orientation', props.ariaOrientation ?? props['aria-orientation']);
    setOrRemoveAttribute(element, 'aria-valuemin', props.ariaValueMin ?? props['aria-valuemin']);
    setOrRemoveAttribute(element, 'aria-valuemax', props.ariaValueMax ?? props['aria-valuemax']);
    setOrRemoveAttribute(element, 'aria-valuenow', props.ariaValueNow ?? props['aria-valuenow']);
    setOrRemoveAttribute(element, 'aria-labelledby', props.ariaLabelledBy ?? props['aria-labelledby']);
    setOrRemoveAttribute(element, 'aria-describedby', props.ariaDescribedBy ?? props['aria-describedby']);
    setOrRemoveAttribute(element, 'aria-invalid', props.ariaInvalid ?? props['aria-invalid']);
    setOrRemoveAttribute(element, 'aria-errormessage', props.ariaErrorMessage ?? props['aria-errormessage']);
    setOrRemoveAttribute(element, 'aria-checked', props['aria-checked']);
    setOrRemoveAttribute(element, 'aria-selected', props['aria-selected']);
    setOrRemoveAttribute(element, 'aria-current', props['aria-current']);
    setOrRemoveAttribute(element, 'aria-readonly', props['aria-readonly']);
    setOrRemoveAttribute(element, 'aria-live', props['aria-live']);
    const ariaDisabled = props.ariaDisabled ?? props['aria-disabled'];
    setOrRemoveAttribute(element, 'aria-disabled', ariaDisabled);
    if (props.type && element.tagName === 'BUTTON') {
        const buttonType = String(props.type);
        if (buttonType === 'button' || buttonType === 'submit' || buttonType === 'reset') {
            element.type = buttonType;
        }
    }
    if (props.form && isFormAssociatedElement(element)) {
        element.setAttribute('form', String(props.form));
    }
    else if (isFormAssociatedElement(element)) {
        element.removeAttribute('form');
    }
    if (element.tagName === 'BUTTON') {
        setOrRemoveAttribute(element, 'name', props.name);
    }
    if (props.type !== undefined && element.tagName === 'INPUT') {
        element.type = String(props.type);
    }
    else if (element.tagName === 'INPUT') {
        element.type = 'text';
    }
    if (props.required !== undefined) {
        element.required =
            props.required === true || props.required === 'true';
    }
    else if (isFormControlElement(element)) {
        element.required = false;
    }
    if (props.min !== undefined) {
        setOrRemoveAttribute(element, 'min', props.min);
    }
    if (props.max !== undefined) {
        setOrRemoveAttribute(element, 'max', props.max);
    }
    else if (element.tagName === 'PROGRESS') {
        element.removeAttribute('max');
    }
    if (props.step !== undefined) {
        setOrRemoveAttribute(element, 'step', props.step);
    }
    if (props.minLength !== undefined) {
        setOrRemoveAttribute(element, 'minlength', props.minLength);
    }
    if (props.maxLength !== undefined) {
        setOrRemoveAttribute(element, 'maxlength', props.maxLength);
    }
    if (element.tagName === 'TEXTAREA') {
        setOrRemoveAttribute(element, 'rows', props.rows);
    }
    if (element.tagName === 'SELECT') {
        applySelectOptions(element, props, context.document);
    }
    setOrRemoveAttribute(element, 'placeholder', props.placeholder);
    if (hasOwn(props, 'value')) {
        applyElementValue(element, nodeId, props.value, context.inputStates);
    }
    else if (element.tagName === 'BUTTON') {
        element.removeAttribute('value');
    }
    else if (element.tagName === 'PROGRESS') {
        element.removeAttribute('value');
    }
    if (hasOwn(props, 'checked')) {
        element.checked = readBooleanProp(props.checked);
    }
    if (hasOwn(props, 'indeterminate') && element.tagName === 'INPUT') {
        element.indeterminate = readBooleanProp(props.indeterminate);
    }
    if (props.disabled !== undefined) {
        const isDisabled = readBooleanProp(props.disabled);
        setDisabled(element, isDisabled);
    }
    else if (isDisableableElement(element)) {
        element.disabled = false;
    }
    if (props.readOnly !== undefined) {
        setReadOnly(element, Boolean(props.readOnly));
    }
    else if (isReadOnlyElement(element)) {
        element.readOnly = false;
    }
    setBooleanAttribute(element, 'hidden', props.hidden);
    if (element.tagName === 'INPUT' || element.tagName === 'SELECT') {
        setBooleanAttribute(element, 'multiple', props.multiple);
    }
    if (element.tagName === 'INPUT') {
        setOrRemoveAttribute(element, 'accept', props.accept);
    }
    setBooleanAttribute(element, 'draggable', props.draggable);
    const isSvgElement = isSvgTag(element.tagName.toLowerCase());
    const href = resolveAttributeValue(props.href);
    const resolvedAriaDisabled = resolveAttributeValue(props.ariaDisabled ?? props['aria-disabled']);
    const resolvedDataDisabled = resolveAttributeValue(props['data-disabled']);
    const isDisabledAnchor = element.tagName === 'A'
        && (resolvedAriaDisabled === true || resolvedAriaDisabled === 'true')
        && (resolvedDataDisabled === true || resolvedDataDisabled === 'true');
    if (href !== undefined && !isSvgElement && !isDisabledAnchor) {
        element.href = String(href);
    }
    else if (element.tagName === 'A') {
        element.removeAttribute('href');
    }
    if (props.target !== undefined) {
        element.target = String(props.target);
    }
    else if (element.tagName === 'A') {
        element.removeAttribute('target');
    }
    if (element.tagName === 'IMG') {
        setOrRemoveAttribute(element, 'src', props.src);
        setOrRemoveAttribute(element, 'alt', props.alt);
        setOrRemoveAttribute(element, 'width', props.width);
        setOrRemoveAttribute(element, 'height', props.height);
    }
    if (element.tagName === 'VIDEO' || element.tagName === 'SOURCE') {
        setOrRemoveAttribute(element, 'src', props.src);
        setOrRemoveAttribute(element, 'type', props.type);
    }
    if (element.tagName === 'VIDEO') {
        setOrRemoveAttribute(element, 'preload', props.preload);
        setOrRemoveAttribute(element, 'poster', props.poster);
        setBooleanAttribute(element, 'controls', props.controls);
        setBooleanAttribute(element, 'autoplay', props.autoPlay ?? props.autoplay);
        setBooleanAttribute(element, 'muted', props.muted);
        setBooleanAttribute(element, 'loop', props.loop);
        setBooleanAttribute(element, 'playsinline', props.playsInline ?? props.playsinline);
    }
    setOrRemoveAttribute(element, 'scope', props.scope);
    setOrRemoveAttribute(element, 'span', props.span);
    setOrRemoveAttribute(element, 'colspan', props.colSpan ?? props.colspan);
    setOrRemoveAttribute(element, 'rowspan', props.rowSpan ?? props.rowspan);
    setOrRemoveAttribute(element, 'data-ui', props['data-ui']);
    setOrRemoveAttribute(element, 'data-loading', props['data-loading']);
    setOrRemoveAttribute(element, 'data-variant', props['data-variant']);
    setOrRemoveAttribute(element, 'data-size', props['data-size']);
    setOrRemoveAttribute(element, 'data-focus-ring', props['data-focus-ring']);
    setOrRemoveAttribute(element, 'data-focus-visible-ring', props['data-focus-visible-ring']);
    setOrRemoveAttribute(element, 'data-icon', props['data-icon']);
    setOrRemoveAttribute(element, 'data-item-content', props['data-item-content']);
    setOrRemoveAttribute(element, 'data-full-width', props['data-full-width']);
    setOrRemoveAttribute(element, 'data-orientation', props['data-orientation']);
    setOrRemoveAttribute(element, 'data-layout', props['data-layout']);
    setOrRemoveAttribute(element, 'data-frame', props['data-frame']);
    setOrRemoveAttribute(element, 'data-invalid', props['data-invalid']);
    setOrRemoveAttribute(element, 'data-error', props['data-error']);
    setOrRemoveAttribute(element, 'data-disabled', props['data-disabled']);
    setOrRemoveAttribute(element, 'data-read-only', props['data-read-only']);
    setOrRemoveAttribute(element, 'data-checked', props['data-checked']);
    setOrRemoveAttribute(element, 'data-indeterminate', props['data-indeterminate']);
    setOrRemoveAttribute(element, 'data-checkbox-root', props['data-checkbox-root']);
    setOrRemoveAttribute(element, 'data-radio-root', props['data-radio-root']);
    setOrRemoveAttribute(element, 'data-state', props['data-state']);
    setOrRemoveAttribute(element, 'data-selected', props['data-selected']);
    setOrRemoveAttribute(element, 'data-emphasized', props['data-emphasized']);
    setOrRemoveAttribute(element, 'data-highlighted', props['data-highlighted']);
    setOrRemoveAttribute(element, 'data-selected-descendant', props['data-selected-descendant']);
    setOrRemoveAttribute(element, 'data-active', props['data-active']);
    setOrRemoveAttribute(element, 'data-dropdown-menu-trigger', props['data-dropdown-menu-trigger']);
    setOrRemoveAttribute(element, 'data-dropdown-menu-item', props['data-dropdown-menu-item']);
    setOrRemoveAttribute(element, 'data-destructive', props['data-destructive']);
    setOrRemoveAttribute(element, 'data-accordion', props['data-accordion']);
    setOrRemoveAttribute(element, 'data-multiple', props['data-multiple']);
    setOrRemoveAttribute(element, 'data-collapsible', props['data-collapsible']);
    setOrRemoveAttribute(element, 'data-value', props['data-value']);
    setOrRemoveAttribute(element, 'data-ownedby', props['data-ownedby']);
    setOrRemoveAttribute(element, 'data-controls', props['data-controls']);
    setOrRemoveAttribute(element, 'data-disclosure', props['data-disclosure']);
    setOrRemoveAttribute(element, 'data-expanded', props['data-expanded']);
    setOrRemoveAttribute(element, 'data-level', props['data-level']);
    setOrRemoveAttribute(element, 'data-selectable', props['data-selectable']);
    setOrRemoveAttribute(element, 'data-has-children', props['data-has-children']);
    setOrRemoveAttribute(element, 'data-has-start', props['data-has-start']);
    setOrRemoveAttribute(element, 'data-has-end', props['data-has-end']);
    setOrRemoveAttribute(element, 'data-draggable', props['data-draggable']);
    setOrRemoveAttribute(element, 'data-droppable', props['data-droppable']);
    setOrRemoveAttribute(element, 'data-reorderable', props['data-reorderable']);
    setOrRemoveAttribute(element, 'data-reparentable', props['data-reparentable']);
    setOrRemoveAttribute(element, 'data-reparent-scope', props['data-reparent-scope']);
    setOrRemoveAttribute(element, 'data-dragging', props['data-dragging']);
    setOrRemoveAttribute(element, 'data-drop-active', props['data-drop-active']);
    setOrRemoveAttribute(element, 'data-drop-position', props['data-drop-position']);
    setOrRemoveAttribute(element, 'data-drop-ready', props['data-drop-ready']);
    setOrRemoveAttribute(element, 'data-empty', props['data-empty']);
    setOrRemoveAttribute(element, 'data-group-selection', props['data-group-selection']);
    setOrRemoveAttribute(element, 'data-select-parents', props['data-select-parents']);
    setOrRemoveAttribute(element, 'data-nested', props['data-nested']);
    setOrRemoveAttribute(element, 'data-parent-active', props['data-parent-active']);
    setOrRemoveAttribute(element, 'data-select-trigger', props['data-select-trigger']);
    setOrRemoveAttribute(element, 'data-select-start', props['data-select-start']);
    setOrRemoveAttribute(element, 'data-options-start', props['data-options-start']);
    setOrRemoveAttribute(element, 'data-modal-trigger', props['data-modal-trigger']);
    setOrRemoveAttribute(element, 'data-modal-content', props['data-modal-content']);
    setOrRemoveAttribute(element, 'data-open', props['data-open']);
    setOrRemoveAttribute(element, 'data-placeholder', props['data-placeholder']);
    setOrRemoveAttribute(element, 'data-placement', props['data-placement']);
    setOrRemoveAttribute(element, 'data-scroll-behavior', props['data-scroll-behavior']);
    setOrRemoveAttribute(element, 'data-striped', props['data-striped']);
    setOrRemoveAttribute(element, 'data-interactive', props['data-interactive']);
    setOrRemoveAttribute(element, 'data-column-border', props['data-column-border']);
    setOrRemoveAttribute(element, 'data-sticky-header', props['data-sticky-header']);
    setOrRemoveAttribute(element, 'data-sticky', props['data-sticky']);
    setOrRemoveAttribute(element, 'data-position', props['data-position']);
    setOrRemoveAttribute(element, 'data-align', props['data-align']);
    setOrRemoveAttribute(element, 'data-submenu', props['data-submenu']);
    setOrRemoveAttribute(element, 'data-status', props['data-status']);
    setOrRemoveAttribute(element, 'data-icon-style', props['data-icon-style']);
    setOrRemoveAttribute(element, 'data-has-icon', props['data-has-icon']);
    setOrRemoveAttribute(element, 'data-has-action', props['data-has-action']);
    setOrRemoveAttribute(element, 'data-toast-id', props['data-toast-id']);
    setOrRemoveAttribute(element, 'data-index', props['data-index']);
    setOrRemoveAttribute(element, 'data-front', props['data-front']);
    setOrRemoveAttribute(element, 'data-visible', props['data-visible']);
    setOrRemoveAttribute(element, 'data-mounted', props['data-mounted']);
    setOrRemoveAttribute(element, 'data-side', props['data-side']);
    if (isSvgElement) {
        setOrRemoveAttribute(element, 'width', props.width);
        setOrRemoveAttribute(element, 'height', props.height);
        setOrRemoveAttribute(element, 'x', props.x);
        setOrRemoveAttribute(element, 'y', props.y);
        setOrRemoveAttribute(element, 'x1', props.x1);
        setOrRemoveAttribute(element, 'y1', props.y1);
        setOrRemoveAttribute(element, 'x2', props.x2);
        setOrRemoveAttribute(element, 'y2', props.y2);
        setOrRemoveAttribute(element, 'cx', props.cx);
        setOrRemoveAttribute(element, 'cy', props.cy);
        setOrRemoveAttribute(element, 'r', props.r);
        setOrRemoveAttribute(element, 'rx', props.rx);
        setOrRemoveAttribute(element, 'ry', props.ry);
        setOrRemoveAttribute(element, 'href', props.href);
        setOrRemoveNamespacedAttribute(element, XLINK_NAMESPACE, 'xlink:href', 'href', props.xlinkHref ?? props['xlink:href']);
        setOrRemoveAttribute(element, 'viewBox', props.viewBox);
        setOrRemoveAttribute(element, 'preserveAspectRatio', props.preserveAspectRatio);
        setOrRemoveAttribute(element, 'fill', props.fill);
        setOrRemoveAttribute(element, 'fill-rule', props.fillRule ?? props['fill-rule']);
        setOrRemoveAttribute(element, 'stroke', props.stroke);
        setOrRemoveAttribute(element, 'opacity', props.opacity);
        setOrRemoveAttribute(element, 'offset', props.offset);
        setOrRemoveAttribute(element, 'd', props.d);
        setOrRemoveAttribute(element, 'transform', props.transform);
        setOrRemoveAttribute(element, 'xmlns', props.xmlns);
        setOrRemoveNamespacedAttribute(element, XMLNS_NAMESPACE, 'xmlns:xlink', 'xlink', props.xmlnsXlink ?? props['xmlns:xlink']);
        setOrRemoveAttribute(element, 'clip-path', props.clipPath ?? props['clip-path']);
        setOrRemoveAttribute(element, 'clip-rule', props.clipRule ?? props['clip-rule']);
        setOrRemoveAttribute(element, 'gradientUnits', props.gradientUnits);
        setOrRemoveAttribute(element, 'gradientTransform', props.gradientTransform);
        setOrRemoveAttribute(element, 'patternUnits', props.patternUnits);
        setOrRemoveAttribute(element, 'patternTransform', props.patternTransform);
        setOrRemoveAttribute(element, 'stop-color', props.stopColor ?? props['stop-color']);
        setOrRemoveAttribute(element, 'stroke-width', props.strokeWidth ?? props['stroke-width']);
        setOrRemoveAttribute(element, 'stroke-linecap', props.strokeLinecap ?? props['stroke-linecap']);
        setOrRemoveAttribute(element, 'stroke-linejoin', props.strokeLinejoin ?? props['stroke-linejoin']);
        setOrRemoveAttribute(element, 'stroke-dasharray', props.strokeDasharray ?? props['stroke-dasharray']);
        setOrRemoveAttribute(element, 'vector-effect', props.vectorEffect ?? props['vector-effect']);
        setOrRemoveAttribute(element, 'shape-rendering', props.shapeRendering ?? props['shape-rendering']);
    }
    const dataKeys = context.nodeDataKeys.get(nodeId) ?? new Set();
    for (const key of dataKeys) {
        delete element.dataset[key];
    }
    dataKeys.clear();
    if (props.data && typeof props.data === 'object') {
        for (const [key, value] of Object.entries(props.data)) {
            element.dataset[key] = String(value);
            dataKeys.add(key);
        }
    }
    context.nodeDataKeys.set(nodeId, dataKeys);
}
function shouldApplyFormControlName(element, _props) {
    if (element.tagName !== 'INPUT' && element.tagName !== 'TEXTAREA' && element.tagName !== 'SELECT') {
        return false;
    }
    return true;
}
function applySelectOptions(select, props, doc) {
    const selectWithSignature = select;
    const options = props.options;
    if (!Array.isArray(options)) {
        return;
    }
    const nextSignature = JSON.stringify({
        options,
        placeholder: props.placeholder,
    });
    if (selectWithSignature.__smoothieOptionsSignature === nextSignature) {
        return;
    }
    while (select.firstChild) {
        select.removeChild(select.firstChild);
    }
    if (typeof props.placeholder === 'string' && props.placeholder.length > 0) {
        const placeholderOption = doc.createElement('option');
        placeholderOption.value = '';
        placeholderOption.disabled = true;
        placeholderOption.textContent = props.placeholder;
        select.appendChild(placeholderOption);
    }
    for (const option of options) {
        if (!option || typeof option !== 'object') {
            continue;
        }
        const normalized = option;
        if (normalized.value === undefined) {
            continue;
        }
        const optionElement = doc.createElement('option');
        optionElement.value = String(normalized.value);
        optionElement.textContent = String(normalized.label ?? normalized.value);
        optionElement.disabled = normalized.disabled === true || normalized.disabled === 'true';
        select.appendChild(optionElement);
    }
    selectWithSignature.__smoothieOptionsSignature = nextSignature;
}
function applyElementValue(element, nodeId, value, inputStates) {
    const nextValue = String(value);
    if (element.tagName === 'PROGRESS') {
        element.value = Number(nextValue);
        return;
    }
    if (element.tagName === 'BUTTON') {
        element.value = nextValue;
        return;
    }
    if (element.tagName === 'SELECT') {
        const select = element;
        if (select.value !== nextValue) {
            select.value = nextValue;
        }
        return;
    }
    if (isTextValueElement(element)) {
        if (inputStates.get(nodeId)?.isComposing) {
            return;
        }
        if (element.value === nextValue) {
            return;
        }
        const selection = captureSelection(element);
        element.value = nextValue;
        restoreSelection(element, selection);
    }
}
function supportsValueElement(element) {
    return element.tagName === 'INPUT'
        || element.tagName === 'TEXTAREA'
        || element.tagName === 'SELECT';
}
function isFormControlElement(element) {
    return supportsValueElement(element);
}
function isDisableableElement(element) {
    return element.tagName === 'INPUT'
        || element.tagName === 'BUTTON'
        || element.tagName === 'TEXTAREA'
        || element.tagName === 'SELECT'
        || element.tagName === 'FIELDSET';
}
function isFormAssociatedElement(element) {
    return element.tagName === 'INPUT'
        || element.tagName === 'BUTTON'
        || element.tagName === 'TEXTAREA'
        || element.tagName === 'SELECT';
}
function isReadOnlyElement(element) {
    return element.tagName === 'INPUT' || element.tagName === 'TEXTAREA';
}
function setDisabled(element, disabled) {
    if (isDisableableElement(element)) {
        element.disabled = disabled;
    }
}
function setReadOnly(element, readOnly) {
    if (isReadOnlyElement(element)) {
        element.readOnly = readOnly;
    }
}
function setInert(element, value) {
    const resolvedValue = typeof value === 'function'
        ? value()
        : value;
    const inertElement = element;
    if (resolvedValue === undefined || resolvedValue === null || resolvedValue === false || resolvedValue === 'false') {
        if ('inert' in inertElement) {
            inertElement.inert = false;
        }
        element.removeAttribute('inert');
        return;
    }
    if ('inert' in inertElement) {
        inertElement.inert = true;
    }
    element.setAttribute('inert', '');
}
function captureSelection(element) {
    if (!supportsTextSelection(element) || element.ownerDocument.activeElement !== element) {
        return null;
    }
    if (element.selectionStart === null || element.selectionEnd === null) {
        return null;
    }
    return {
        start: element.selectionStart,
        end: element.selectionEnd,
        direction: element.selectionDirection,
        value: element.value,
    };
}
function restoreSelection(element, selection) {
    if (!selection || !supportsTextSelection(element)) {
        return;
    }
    const nextSelection = deriveNextSelection(selection, element.value);
    const nextStart = Math.min(nextSelection.start, element.value.length);
    const nextEnd = Math.min(nextSelection.end, element.value.length);
    element.setSelectionRange(nextStart, nextEnd, selection.direction ?? undefined);
}
function deriveNextSelection(selection, nextValue) {
    const currentValue = selection.value;
    const { start, end } = selection;
    if (currentValue === nextValue) {
        return { start, end };
    }
    const formatterAware = deriveFormatterAwareSelection(selection, nextValue);
    if (formatterAware) {
        return formatterAware;
    }
    if (start === currentValue.length && end === currentValue.length) {
        return { start: nextValue.length, end: nextValue.length };
    }
    const prefix = currentValue.slice(0, start);
    const suffix = currentValue.slice(end);
    if (nextValue.startsWith(prefix) && nextValue.endsWith(suffix)) {
        return {
            start,
            end: Math.max(start, nextValue.length - suffix.length),
        };
    }
    if (start === end) {
        const cursorSuffix = currentValue.slice(start);
        if (nextValue.endsWith(cursorSuffix)) {
            const nextCursor = nextValue.length - cursorSuffix.length;
            return { start: nextCursor, end: nextCursor };
        }
        if (nextValue.startsWith(prefix)) {
            return { start, end };
        }
    }
    else {
        const selectionLength = end - start;
        if (nextValue.endsWith(suffix)) {
            const nextEnd = nextValue.length - suffix.length;
            return {
                start: Math.max(0, nextEnd - selectionLength),
                end: nextEnd,
            };
        }
        if (nextValue.startsWith(prefix)) {
            return {
                start,
                end: Math.min(start + selectionLength, nextValue.length),
            };
        }
    }
    const delta = nextValue.length - currentValue.length;
    return {
        start: Math.max(0, start + delta),
        end: Math.max(0, end + delta),
    };
}
function deriveFormatterAwareSelection(selection, nextValue) {
    const currentSignificant = getSignificantSequence(selection.value);
    const nextSignificant = getSignificantSequence(nextValue);
    if (currentSignificant.length === 0 || currentSignificant !== nextSignificant) {
        return null;
    }
    const nextStart = findBoundaryBySignificantCount(nextValue, countSignificantChars(selection.value, selection.start), 'start');
    const nextEnd = findBoundaryBySignificantCount(nextValue, countSignificantChars(selection.value, selection.end), selection.start === selection.end ? 'caret' : 'end');
    return {
        start: nextStart,
        end: Math.max(nextStart, nextEnd),
    };
}
function getSignificantSequence(value) {
    return Array.from(value).filter((char) => isSignificantChar(char)).join('');
}
function countSignificantChars(value, boundary) {
    let count = 0;
    let offset = 0;
    for (const char of value) {
        if (offset >= boundary) {
            break;
        }
        offset += char.length;
        if (isSignificantChar(char)) {
            count += 1;
        }
    }
    return count;
}
function findBoundaryBySignificantCount(value, significantCount, mode) {
    if (significantCount <= 0) {
        return mode === 'end' ? 0 : skipFormattingForward(value, 0);
    }
    let seen = 0;
    let offset = 0;
    for (const char of value) {
        offset += char.length;
        if (isSignificantChar(char)) {
            seen += 1;
            if (seen === significantCount) {
                return mode === 'end' ? offset : skipFormattingForward(value, offset);
            }
        }
    }
    return value.length;
}
function skipFormattingForward(value, offset) {
    let nextOffset = offset;
    while (nextOffset < value.length) {
        const char = value[nextOffset];
        if (char === undefined || isSignificantChar(char)) {
            break;
        }
        nextOffset += char.length;
    }
    return nextOffset;
}
function isSignificantChar(char) {
    return /[\p{L}\p{N}]/u.test(char);
}
function supportsTextSelection(element) {
    if (element.tagName === 'TEXTAREA') {
        return true;
    }
    return ['text', 'search', 'tel', 'url', 'password'].includes(element.type);
}
function isTextValueElement(element) {
    return element.tagName === 'INPUT' || element.tagName === 'TEXTAREA';
}
function applyStyleObject(element, styles) {
    for (const [key, value] of Object.entries(styles)) {
        if (value === undefined || value === null) {
            continue;
        }
        if (key.startsWith('--') || key.includes('-')) {
            element.style.setProperty(key, String(value));
            continue;
        }
        element.style[key] = String(value);
    }
}
function setOrRemoveAttribute(element, name, value) {
    const resolvedValue = resolveAttributeValue(value);
    if (resolvedValue === undefined || resolvedValue === null) {
        element.removeAttribute(name);
        return;
    }
    element.setAttribute(name, String(resolvedValue));
}
function setOrRemoveNamespacedAttribute(element, namespace, qualifiedName, localName, value) {
    const resolvedValue = resolveAttributeValue(value);
    if (resolvedValue === undefined || resolvedValue === null) {
        element.removeAttributeNS(namespace, localName);
        return;
    }
    element.setAttributeNS(namespace, qualifiedName, String(resolvedValue));
}
function resolveAttributeValue(value) {
    return typeof value === 'function'
        ? value()
        : value;
}
function setBooleanAttribute(element, name, value) {
    const resolvedValue = resolveAttributeValue(value);
    if (resolvedValue === undefined || resolvedValue === null || resolvedValue === false || resolvedValue === 'false') {
        element.removeAttribute(name);
        if (name in element) {
            element[name] = false;
        }
        return;
    }
    element.setAttribute(name, '');
    if (name in element) {
        element[name] = true;
    }
}
function hasOwn(props, key) {
    return Object.prototype.hasOwnProperty.call(props, key);
}
function readBooleanProp(value) {
    return Boolean(typeof value === 'function' ? value() : value);
}
//# sourceMappingURL=attributes.js.map